import React from 'react';
import CounterReport from './components/CounterReport';
import ChartReport from './components/ChartReport';
import TableReport from './components/TableReport';

const GrossProfitReportPage = () => {
  return (
    <React.Fragment>
      <div className='bw_main_wrapp'>
        <CounterReport />
        <ChartReport />
        <TableReport />
      </div>
    </React.Fragment>
  );
};

export default GrossProfitReportPage;
